export default String.raw`
(function () {
    if (!body) {
        var body = $("body");
    }

    $(document).ready(function () {
		function showDifferentNumberOfPhantomVariants() {
			$(".product-item__phantom-first").each(function () {
				const variant = $(this).children(":not(.more-items)");
				const numberOfVariants = variant.length;
				const containerWidth = $(this).outerWidth();

				$(this).find(".more-items").remove();
				variant.hide();
				
                const firstLink = $(this).find("a").first();
                let href;
                if (firstLink.length > 0) {
                    href = firstLink.attr("href");
                } else {
                    href = "#";
                }
				
				if ($(this).children().hasClass("product-item__phantom-colorWrapper")) {
					if (containerWidth >= 260 && numberOfVariants > 6) {
						variant.slice(0, 5).show();
						$(this).append("<a class='more-items' href='" + href + "'>+" + (numberOfVariants - 5) + "</a>");
					} else if (containerWidth >= 210 && containerWidth <= 260 && numberOfVariants > 5) {
						variant.slice(0, 4).show();
						$(this).append("<a class='more-items' href='" + href + "'>+" + (numberOfVariants - 4) + "</a>");
					} else if (containerWidth <= 210 && numberOfVariants > 4) {
						variant.slice(0, 3).show();
						$(this).append("<a class='more-items' href='" + href + "'>+" + (numberOfVariants - 3) + "</a>");
					} else {
						variant.show();
					}
				} else {
					if (containerWidth >= 230 && numberOfVariants > 5) {
						variant.slice(0, 4).show();
						$(this).append("<a class='more-items' href='" + href + "'>+" + (numberOfVariants - 4) + "</a>");
					} else if (containerWidth >= 190 && containerWidth <= 230 && numberOfVariants > 4) {
						variant.slice(0, 3).show();
						$(this).append("<a class='more-items' href='" + href + "'>+" + (numberOfVariants - 3) + "</a>");
					} else if (containerWidth <= 190 && numberOfVariants > 3) {
						variant.slice(0, 2).show();
						$(this).append("<a class='more-items' href='" + href + "'>+" + (numberOfVariants - 2) + "</a>");
					} else {
						variant.show();
					}
				}
			});
		}
        $(window).resize(function () {
            showDifferentNumberOfPhantomVariants();
        });
    });

    $(".products-page-js").on("click", ".product-item__phantom .select-js", function () {
        const $options = $(this).find(".options-js");
        const $svg = $(this).find("svg");
        const $parentContainer = $(this).closest(".image-container");

        $options.toggle();

        if ($options.is(":visible")) {
            $svg.css("transform", "rotate(180deg)");
            $parentContainer.css("overflow", "unset");
        } else {
            $svg.css("transform", "rotate(0deg)");
            $parentContainer.css("overflow", "hidden");
        }
    });

    $(".products-page-js").on("mouseenter", ".product-phantom-js", function () {
        const productContainer = $(this);
        const hasAttributes = $(this).find(".product-item__phantom").data("attributes");
        const settingsGrapicalVariantsPresentation = $(this).find(".product-item__phantom").data("settings");

        if ($(window).width() > 768 && (hasAttributes === "true" || hasAttributes === true) && settingsGrapicalVariantsPresentation !== "Variants_No") {
            showAttributesOnHover(productContainer);
        }
    });

    $(".products-page-js").on("mouseleave", ".product-phantom-js", function () {
        const productContainer = $(this);
        const hasAttributes = $(this).find(".product-item__phantom").data("attributes");

        if ($(window).width() > 768 && (hasAttributes === "true" || hasAttributes === true)) {
            if (productContainer.find(".product-item__phantom .select-js").children().length > 0) {
                const $selectContainer = productContainer.find(".product-item__phantom .select-js");

                let $options = $selectContainer.find(".options-js");
                const $selectContainerRef = $selectContainer.data("ref");
                if ($selectContainerRef) {
                    $options = $("[data-select-id=" + $selectContainerRef + "]");
                }

                const $svg = $selectContainer.find("svg");
                const $parentContainer = $selectContainer.closest(".image-container");

                if ($options.is(":visible")) {
                    productContainer.find(".product-item__phantom").addClass("visiblePhantomContainer");
                } else {
                    productContainer.find(".product-item__phantom").removeClass("visiblePhantomContainer");
                }

                if (!$options.is(":visible")) {
                    productContainer.find(".product-item__phantom").removeClass("visiblePhantomContainer");
                    $svg.css("transform", "rotate(0deg)");
                    $parentContainer.css("overflow", "hidden");
                    $options.css("display", "none");
                }
            } else {
                productContainer.find(".product-item__phantom").removeClass("visiblePhantomContainer");
            }
        }
    });

    // variants on products list graphic / color / select
    const showAttributesOnHover = (productContainer) => {
        const phantomProduct = productContainer.find(".product-item__phantom");

        if ((phantomProduct.data("clip") === "true" || phantomProduct.data("clip") === true) && phantomProduct.data("set-attrs") !== true) {
            $(phantomProduct).data("set-attrs", true);
            const base = phantomProduct.data("base");
            const url = phantomProduct.data("url");
            const link = url ? ((url.indexOf('//') === 0 || url.indexOf('://') > -1) ? url : (base || $('base').attr('href') || '') + url) : '';

            if (link) {
                $.get(
                    link,
                    {
                        __collection:
                            "product-presentation.Product.Supplies.Supplies|product-presentation.Product.Supplies.AttributeNames|product-presentation.Product.Id|product-presentation.Product.ImageId|product-presentation.Product.Image.Link|product-presentation.Product.Image.ExternalUrl",
                    },
                    function (res) {
                        const phantom = res.collection["product-presentation.Product.Supplies.Supplies"];
                        const productId = res.collection["product-presentation.Product.Id"];
                        const attributeName = res.collection["product-presentation.Product.Supplies.AttributeNames"][0]?.Name;
                        const variants = {};
                        const variantsArr = [];
                        let variantsCounter = 0;
                        for (const index in phantom) {
                            const variantValue = phantom[index].ValueId;
                            const name = phantom[index].Object;
                            const sizes = phantom[index].Supplies;
                            variantsCounter += 1;
                            if (sizes && sizes.length > 0) {
                                for (const sizeIndex in sizes) {
                                    const sup = sizes[sizeIndex];
                                    let isNew = false;
                                    if (!variants[variantValue]) {
                                        isNew = true;

                                        variants[variantValue] = {};
                                        variants[variantValue].Sizes = [];
                                        if (sup.Product) {
                                            variants[variantValue].ImageId = sup.Product.ImageId;
                                        } else if (sup.Supplies && sup.Supplies.length > 0 && sup.Supplies[0].Product && sup.Supplies[0].Product.ImageId) {
                                            variants[variantValue].ImageId = sup.Supplies[0].Product.ImageId;
                                        } else {
                                            variants[variantValue].ImageId = res.collection["product-presentation.Product.ImageId"];
                                        }

                                        if (sup.Product) {
                                            variants[variantValue].Link = sup.Product.Link;
                                        } else if (sup.Supplies && sup.Supplies.length > 0 && sup.Supplies[0].Product && sup.Supplies[0].Product.Link) {
                                            variants[variantValue].Link = sup.Supplies[0].Product.Link;
                                        } else {
                                            variants[variantValue].Link = res.collection["product-presentation.Product.Image.Link"];
                                        }

                                        const hasSupplies = sup.Supplies && sup.Supplies.length > 0;
                                        let suppliesKey;
                                        if (hasSupplies) {
                                            suppliesKey = sup.Supplies[0].Key;
                                        } else {
                                            suppliesKey = null;
                                        }
                                        variants[variantValue].Key = sup.Key || suppliesKey || sup.ValueId;
                                        variants[variantValue].Parent = false;

                                        if (sup.Product && sup.Product.Image && sup.Product.Image.ExternalUrl) {
                                            variants[variantValue].ExternalUrl = sup.Product.Image.ExternalUrl;
                                        } else if (sup.Supplies?.length > 0 && sup.Supplies[0].Product?.Image && sup.Supplies[0].Product.ExternalUrl) {
                                            variants[variantValue].ExternalUrl = null;
                                        } else {
                                            variants[variantValue].ExternalUrl = null;
                                        }
                                    }

                                    if (sup.Product && sup.Product.Id == productId) {
                                        variants[variantValue].Parent = true;
                                        variants[variantValue].Sizes.push({
                                            Value: sup.Value,
                                            Key: sup.Key || sup.ValueId,
                                            Parent: true,
                                        });
                                    } else {
                                        variants[variantValue].Sizes.push({
                                            Value: sup.Value,
                                            Key: sup.Key || sup.ValueId,
                                            Parent: false,
                                        });
                                    }

                                    if (isNew) {
                                        variantsArr.push(variants[variantValue]);
                                    }
                                }
                            } else {
                                let isNew = false;
                                if (!variants[variantValue]) {
                                    isNew = true;
                                    variants[variantValue] = {};
                                    variants[variantValue].Key = variantValue;
                                    variants[variantValue].Value = ""; //phantom[index].Value;
                                    variants[variantValue].Parent = false;
                                    variants[variantValue].Sizes = [];

                                    if (phantom[index].Product) {
                                        variants[variantValue].ImageId = phantom[index].Product.ImageId;
                                    } else {
                                        variants[variantValue].ImageId = res.collection["product-presentation.Product.ImageId"];
                                    }
                                    variants[variantValue].Link = phantom[index]?.Product?.Image?.Link || res.collection?.["product-presentation.Product.Image.Link"];
                                    variants[variantValue].ExternalUrl = phantom[index]?.Product?.Image?.Link?.ExternalUrl || res.collection["product-presentation.Product.Image.ExternalUrl"] || null;

                                    variants[variantValue].Sizes.push({
                                        Value: variants[variantValue].Value,
                                        Key: variants[variantValue].Key,
                                        Parent: false,
                                    });
                                }

                                if (phantom[index].Product && phantom[index].Product.Id == productId) {
                                    variants[variantValue].Parent = true;
                                }

                                if (isNew) {
                                    variantsArr.push(variants[variantValue]);
                                }
                            }
                            variants[variantValue].Name = name;

                            if (!variants[variantValue].ExternalUrl) {
                                if (!variants[variantValue].Link) {
                                    variants[variantValue].Link = res.collection["product-presentation.Product.Image.Link"];
                                }
                            }
                        }
                        const shopUrl = this.url.split("?")[0];
                        for (const index in variantsArr) {
                            if (variantsArr.length > 1) {
                                let attrUrl = "";
                                if (variantsArr[index].Sizes) {
                                    for (const sizeIndex in variantsArr[index].Sizes) {
                                        attrUrl = shopUrl + "?keys=" + variantsArr[index].Sizes[sizeIndex].Key;
                                        variantsArr[index].Sizes[sizeIndex].ProductUrl = attrUrl;
                                    }
                                } else {
                                    attrUrl = shopUrl + "?keys=" + variantsArr[index].Key;
                                    variantsArr[index].ProductUrl = attrUrl;
                                }
                            } else {
                                let attrUrl = "";
                                if (variantsArr[index].Sizes) {
                                    for (const sizeIndex in variantsArr[index].Sizes) {
                                        attrUrl = shopUrl + "?keys=" + variantsArr[index].Key + "," + variantsArr[index].Sizes[sizeIndex].Key;
                                        variantsArr[index].Sizes[sizeIndex].ProductUrl = attrUrl;
                                    }
                                } else {
                                    attrUrl = shopUrl + "?keys=" + variantsArr[index].Key;
                                    variantsArr[index].ProductUrl = attrUrl;
                                }
                            }
                        }
                        if (__graphicalVariantsPresentation === "Variants_Colors") {
                            const container = $(phantomProduct);
                            container.addClass("product-item__phantom-withColors");
                            const containerColors = container.find(".product-item__phantom-first");
                            let isParent = false;

                            for (const supply in variantsArr) {
                                let variantImage = "";
                                let isImage = true;

                                if (variantsArr[supply].ExternalUrl) {
                                    variantImage = variantsArr[supply].ExternalUrl;
                                } else if (variantsArr[supply].ImageId && variantsArr[supply].Link) {
                                    variantImage = "img/medium/" + variantsArr[supply].ImageId + "/" + variantsArr[supply].Link;
                                } else {
                                    isImage = false;
                                    variantImage = "";
                                }

                                const colorMappings = [];
                                const colorsData = __grapicalVariantsPresentationColorsData.split("|||");

                                for (const color in colorsData) {
                                    colorMappings.push(colorsData[color]);
                                }

                                let bgColorValue = "";
                                let borderColorValue = "";
                                let noBgColorValue = false;

                                for (const colorValue in colorMappings) {
                                    const colorValueName = colorMappings[colorValue].split("||")[0].toLowerCase();
                                    const colorValueHash = colorMappings[colorValue].split("||")[1];
                                    const colorValueToCheck = variantsArr[supply].Name.toString().toLowerCase();
                                    if (colorValueName === colorValueToCheck) {
                                        bgColorValue = colorValueHash;
                                    }
                                }

                                if (bgColorValue == "") {
                                    noBgColorValue = true;
                                    bgColorValue = "#FFFFFF";
                                }

                                if (bgColorValue !== "#FFFFFF" || bgColorValue !== __primaryPageBg) {
                                    borderColorValue = bgColorValue;
                                }
                                if (bgColorValue === "#FFFFFF") {
                                    borderColorValue = "#2e2e2e";
                                }

                                const productLink = shopUrl + "?keys=" + variantsArr[supply].Key;

                                if (noBgColorValue === false) {
                                    if (isImage) {
                                        containerColors.append(
                                            '<div class="product-item__phantom-colorWrapper" data-image-id="' +
                                                supply +
                                                '" data-alt="' +
                                                variantsArr[supply].Name +
                                                '" data-image="' +
                                                variantImage +
                                                '"><a title="' +
                                                variantsArr[supply].Name +
                                                '" href="' +
                                                productLink +
                                                '"><div class="product-item__phantom-color" style="background: ' +
                                                bgColorValue +
                                                "; border-color: " +
                                                borderColorValue +
                                                ';"></div></a></div>'
                                        );
                                    } else {
                                        containerColors.append(
                                            '<div class="product-item__phantom-colorWrapper" data-image-id="' +
                                                supply +
                                                '" data-alt="' +
                                                variantsArr[supply].Name +
                                                '" data-image="false"><a title="' +
                                                variantsArr[supply].Name +
                                                '" href="' +
                                                productLink +
                                                '"><div class="product-item__phantom-color" style="background: ' +
                                                bgColorValue +
                                                "; border-color: " +
                                                borderColorValue +
                                                ';"></div></a></div>'
                                        );
                                    }

                                    if (variantsArr[supply].Parent == true) {
                                        isParent = true;
                                        containerColors.find(".product-item__phantom-colorWrapper").eq(supply).data("parent", "1");
                                        containerColors.find(".product-item__phantom-colorWrapper").eq(supply).addClass("product-item__phantom-active");
                                    }
                                }
                            }

                            if (isParent == false) {
                                containerColors.find(".product-item__phantom-colorWrapper").eq(0).data("parent", "1");
                                containerColors.find(".product-item__phantom-colorWrapper").eq(0).addClass("product-item__phantom-active");
                            }

                            const variant = containerColors.children(":not(.more-items)");
                            const numberOfVariants = variant.length;
                            const containerWidth = containerColors.outerWidth();
                            const firstLink = containerColors.find(".product-item__phantom-colorWrapper a").first();
                            let href;
                            if (firstLink.length > 0) {
                                href = firstLink.attr("href");
                            } else {
                                href = "#";
                            }

                            containerColors.find(".more-items").remove();
                            variant.hide();
							
                            if (containerWidth >= 260 && numberOfVariants > 6) {
                                variant.slice(0, 5).show();
    							containerColors.append("<a class='more-items' href='" + href + "'>+" + (numberOfVariants - 5) + "</a>");
                            } else if (containerWidth >= 210 && containerWidth <= 260 && numberOfVariants > 5) {
                                variant.slice(0, 4).show();
    							containerColors.append("<a class='more-items' href='" + href + "'>+" + (numberOfVariants - 4) + "</a>");
                            } else if (containerWidth <= 210 && numberOfVariants > 4) {
                                variant.slice(0, 3).show();
    							containerColors.append("<a class='more-items' href='" + href + "'>+" + (numberOfVariants - 3) + "</a>");
                            } else {
                                variant.show();
                            }
                        } else if (__graphicalVariantsPresentation === "Variants_Thumbnails") {
                            const container = $(phantomProduct);
                            const containerPhotos = container.find(".product-item__phantom-first");
                            containerPhotos.addClass("withPhotos");
                            let isParent = false;

                            for (supply in variantsArr) {
                                let variantImage = "";
                                let isImage = true;

                                if (variantsArr[supply].ExternalUrl) {
                                    variantImage = variantsArr[supply].ExternalUrl;
                                } else if (variantsArr[supply].ImageId && variantsArr[supply].Link) {
                                    variantImage = "img/medium/" + variantsArr[supply].ImageId + "/" + variantsArr[supply].Link;
                                } else {
                                    if (res.collection["product-presentation.Product.ImageId"] && res.collection["product-presentation.Product.Image.Link"]) {
                                        variantImage = "img/medium/" + res.collection["product-presentation.Product.ImageId"] + "/" + res.collection["product-presentation.Product.Image.Link"];
                                    } else if (res.collection["product-presentation.Product.Image.ExternalUrl"]) {
                                        variantImage = res.collection["product-presentation.Product.Image.ExternalUrl"];
                                    } else {
                                        isImage = false;
                                        variantImage = "";
                                    }
                                }

                                const productLink = shopUrl + "?keys=" + variantsArr[supply].Key;

                                if (isImage) {
                                    containerPhotos.append('<div class="product-item__phantom-image" data-image-id="' + supply + '" data-alt="' + variantsArr[supply].Name + '" data-image="' + variantImage + '"></div>');
                                    containerPhotos
                                        .find(".product-item__phantom-image")
                                        .eq(supply)
                                        .append('<a title="' + variantsArr[supply].Name + '" href="' + productLink + '"><img class="product-item__phantom-img" alt="' + variantsArr[supply].Name + '" src="' + variantImage + '"/></a>');
                                } else {
                                    containerPhotos.append('<div class="product-item__phantom-image" data-image-id="' + supply + '" data-alt="' + variantsArr[supply].Name + '" data-image="false"></div>');
                                    containerPhotos
                                        .find(".product-item__phantom-image")
                                        .eq(supply)
                                        .append('<a title="' + variantsArr[supply].Name + '" href="' + productLink + '"><svg class="svgIcon"><use xlink:href="css/img/icons-sprite.svg#image-light"></use></svg></a>');
                                }

                                if (variantsArr[supply].Parent == true) {
                                    isParent = true;
                                    containerPhotos.find(".product-item__phantom-image").eq(supply).data("parent", "1");
                                    containerPhotos.find(".product-item__phantom-image").eq(supply).addClass("product-item__phantom-active");
                                }
                            }

                            if (isParent == false) {
                                containerPhotos.find(".product-item__phantom-image").eq(0).data("parent", "1");
                                containerPhotos.find(".product-item__phantom-image").eq(0).addClass("product-item__phantom-active");
                            }

                            const variant = containerPhotos.children(":not(.more-items)");
                            const numberOfVariants = variant.length;
                            const containerWidth = containerPhotos.outerWidth();
                            const firstLink = containerPhotos.find(".product-item__phantom-image a").first();
                            let href;
                            if (firstLink.length > 0) {
                                href = firstLink.attr("href");
                            } else {
                                href = "#";
                            }

                            containerPhotos.find(".more-items").remove();
                            variant.hide();

                            if (containerWidth >= 230 && numberOfVariants > 5) {
                                variant.slice(0, 4).show();
                                containerPhotos.append("<a class='more-items' href='" + href + "'>+" + (numberOfVariants - 4) + "</a>");
                            } else if (containerWidth >= 190 && containerWidth <= 230 && numberOfVariants > 4) {
                                variant.slice(0, 3).show();
                                containerPhotos.append("<a class='more-items' href='" + href + "'>+" + (numberOfVariants - 3) + "</a>");
                            } else if (containerWidth <= 190 && numberOfVariants > 3) {
                                variant.slice(0, 2).show();
                                containerPhotos.append("<a class='more-items' href='" + href + "'>+" + (numberOfVariants - 2) + "</a>");
                            } else {
                                variant.show();
                            }
                        } else if (__graphicalVariantsPresentation === "Variants_DropDownList") {
                            const container = $(phantomProduct);
                            const containerSelect = container.find(".product-item__phantom-first");
                            let isParent = false;
                            const label = container.find(".input-info-js");
                            label.text(attributeName);
                            label.attr("data-attribute-name", attributeName);

                            for (supply in variantsArr) {
                                const productLink = shopUrl + "?keys=" + variantsArr[supply].Key;

                                if (variantsArr[supply].Parent == true) {
                                    isParent = true;
                                    container.find(".product-item__phantom--select-active").append('<a class="product-item__phantom--option-link" href="' + productLink + '">' + variantsArr[supply].Name + "</a>");
                                }

                                if (variantsArr[supply].Parent === false) {
                                    containerSelect.append('<li class="product-item__phantom--option"><a class="product-item__phantom--option-link" href="' + productLink + '">' + variantsArr[supply].Name + "</a></li>");
                                }
                            }

                            if (isParent == false) {
                                containerSelect.find(".product-item__phantom--select").eq(0).data("parent", "1");
                                containerSelect.find(".product-item__phantom--select").eq(0).addClass("product-item__phantom-active");
                            }
                        } else {
                            console.warn("Unsupported graphical variants presentation type:", __graphicalVariantsPresentation);
                        }

                        if (productContainer.find(".product-item__phantom .product-item__phantom-first").children().not("svg").length > 0) {
                            productContainer.find(".product-item__phantom").addClass("visiblePhantomContainer");
                        }
                        if (productContainer.find(".product-item__phantom .product-item__phantom-first").children().length === 0) {
                            productContainer.find(".product-item__phantom").addClass("visiblePhantomContainerImportant");
                        }
                    }
                );
            }
        } else if ((phantomProduct.data("poly") === "true" || phantomProduct.data("poly") === true) && phantomProduct.data("set-attrs") !== true && __graphicalVariantsPresentation == "Variants_Colors") {
            const product = phantomProduct;
            const url = product.data("url");
            product.data("set-attrs", true);
            const variantsColorArr = __grapicalVariantsPresentationColorsData.split("|||");

            const currentId = product.data("id");
            let prodIndex;
            $(".product-item__new").each(function (index) {
                const listId = $(".product-item__new").eq(index).data("id");
                if (listId == currentId) {
                    prodIndex = index;
                }
            });

            $.get("", { __collection: "products.Products[" + prodIndex + "]" }, function (res) {
                if (res.collection) {
                    let attrPoly = null;
                    if (res.collection.AttributesList) {
                        attrPoly = res.collection.AttributesList.AttributesPolyvalent;
                    }
                    let attrNormal = null;
                    if (res.collection.AttributesList) {
                        attrNormal = res.collection.AttributesList.Attributes;
                    }
                    let attrIndex = 0;
                    let isPoly = false;
                    let isAttr = false;
                    let isColorAttr = false;

                    if (attrPoly) {
                        for (const attr in attrPoly) {
                            if (isColorAttr == false) {
                                for (const value in attrPoly[attr].Values) {
                                    for (const colorValue in variantsColorArr) {
                                        const colorValueName = variantsColorArr[colorValue].split("||")[0].toLowerCase();
                                        const colorValueToCheck = attrPoly[attr].Values[value].Value.toString().toLowerCase();
                                        if (colorValueName == colorValueToCheck) {
                                            isColorAttr = true;
                                            isPoly = true;
                                            attrIndex = attr;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    if (isColorAttr == false && attrNormal) {
                        for (const attr in attrNormal) {
                            if (isColorAttr == false) {
                                for (const value in attrNormal[attr].Values) {
                                    for (const colorValue in variantsColorArr) {
                                        const colorValueName = variantsColorArr[colorValue].split("||")[0].toLowerCase();
                                        const colorValueToCheck = attrNormal[attr].Values[value].Value.toString().toLowerCase();
                                        if (colorValueName == colorValueToCheck) {
                                            isColorAttr = true;
                                            isAttr = true;
                                            attrIndex = attr;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    if (isColorAttr && (isPoly || isAttr)) {
                        product.addClass("product-item__phantom-withColors");
                        const containerColors = product.find(".product-item__phantom-first");
                        let currentAttr;
                        if (isPoly) {
                            currentAttr = attrPoly[attrIndex].Values;
                        } 
                        if (!isPoly && isAttr) {
                            currentAttr = attrNormal[attrIndex].Values;
                        }

                        let counter = 0;
                        for (const attr in currentAttr) {
                            const colorMappingsArr = [];
                            const colorsData = __grapicalVariantsPresentationColorsData.split("|||");

                            for (const color in colorsData) {
                                colorMappingsArr.push(colorsData[color]);
                            }

                            let bgColorValue = "";
                            let borderColorValue = "";
                            let noBgColorValue = false;

                            for (const colorValue in colorMappingsArr) {
                                const colorValueName = colorMappingsArr[colorValue].split("||")[0].toLowerCase();
                                const colorValueHash = colorMappingsArr[colorValue].split("||")[1];
                                const colorValueToCheck = currentAttr[attr].Value.toString().toLowerCase();
                                if (colorValueName === colorValueToCheck) {
                                    bgColorValue = colorValueHash;
                                }
                            }

                            if (bgColorValue == "") {
                                bgColorValue = "#FFFFFF";
                                noBgColorValue = true;
                            }

                            if (bgColorValue !== "#FFFFFF" || bgColorValue !== __primaryPageBg) {
                                borderColorValue = bgColorValue;
                            }

                            const shopUrl = url.split("?")[0];
                            const productLink = shopUrl + "?keys=" + currentAttr[attr].ValueId;

                            if (noBgColorValue === false) {
                                containerColors.append(
                                    '<div class="product-item__phantom-colorWrapper poly" data-image-id="' +
                                        attr +
                                        '" data-alt="' +
                                        currentAttr[attr].Value +
                                        '" data-image="false"><a title="' +
                                        currentAttr[attr].Value +
                                        '" href="' +
                                        productLink +
                                        '"><div class="product-item__phantom-color" style="background: ' +
                                        bgColorValue +
                                        "; border-color: " +
                                        borderColorValue +
                                        ';"></div></a></div>'
                                );
                            }

                            counter += 1;
                        }

                        containerColors.find(".product-item__phantom-colorWrapper").eq(0).data("parent", "1");
                        containerColors.find(".product-item__phantom-colorWrapper").eq(0).addClass("product-item__phantom-active");

                        const variant = containerColors.children(":not(.more-items)");
                        const numberOfVariants = variant.length;
                        const containerWidth = containerColors.outerWidth();
						const firstLink = containerColors.find(".product-item__phantom-colorWrapper a").first();
                        let href;
                        if (firstLink.length > 0) {
                            href = firstLink.attr("href");
                        } else {
                            href = "#";
                        }
						
                        containerColors.find(".more-items").remove();
                        variant.hide();

                        if (containerWidth >= 260 && numberOfVariants > 6) {
                            variant.slice(0, 5).show();
                            containerColors.append("<a class='more-items' href='" + href + "'>+" + (numberOfVariants - 5) + "</a>");
                        } else if (containerWidth >= 210 && containerWidth <= 260 && numberOfVariants > 5) {
                            variant.slice(0, 4).show();
                            containerColors.append("<a class='more-items' href='" + href + "'>+" + (numberOfVariants - 4) + "</a>");
                        } else if (containerWidth <= 210 && numberOfVariants > 4) {
                            variant.slice(0, 3).show();
                            containerColors.append("<a class='more-items' href='" + href + "'>+" + (numberOfVariants - 3) + "</a>");
                        } else {
                            variant.show();
                        }
                    }
                }
            });
        } else {
            console.warn("Product phantom does not meet clip or poly conditions");
        }
        if (phantomProduct.data("clip") === "true" || phantomProduct.data("clip") === true) {
            if (productContainer.find(".product-item__phantom .product-item__phantom-first").children().length > 0 || productContainer.find(".product-item__phantom .product-item__phantom-first").data("attributes") == true) {
                productContainer.find(".product-item__phantom").addClass("visiblePhantomContainer");
            }
        }
    };

    function updateProductItemsInCartState(productsInCart) {
        $(".product-item-js").each(function(index) {
            const productId = parseInt($(this).find(".isInCartId").val());
            if (!isNaN(productId)) {
                const isInCart = app.checkIfProductIsInCart(productsInCart, productId);
                app.enableDisableInCartButton(isInCart, 2, index);
            }
        });
    }

    if ($(".products-page-js").length > 0) {
        // PRODUCT LIST's features implementation
        function ProductList(listContainerSelector, productItemSelector, classSuffix, minQty, rangeValidatorSelector, changableValidationClass) {
            this.listContainer = $(listContainerSelector);
            this.classSuffix = classSuffix || "";
            this.min = minQty;
            this.changableValidationClass = changableValidationClass || null;
            this.rangeValidators = $("." + this.changableValidationClass + rangeValidatorSelector);
            this.productItemSelector = productItemSelector;

            var classRegex = new RegExp("[\\w|-]*" + classSuffix);
            let nameFromHTML = null;
            if ($(listContainerSelector).length > 0) {
                nameFromHTML = $(listContainerSelector).attr("class").match(classRegex)[0].replace(classSuffix, "");
            }
            let nameWhenThresholds = null;
            if ($(listContainerSelector).hasClass("with-thresholds-js")) {
                nameWhenThresholds = "list";
            }

            this.selectedViewName = nameWhenThresholds || window.app.getCookie("selectedViewName") || nameFromHTML || "quick-shopping";

            function handleChangeViewResponse(data, viewName, $clickedButton, thisRef) {
                const divContainer = $(".view-container-js");
                divContainer.html(data.template);
                if (viewName === "quick-shopping" && data.collection > 0) {
                    $(".quick-shopping-buttons-container-js").removeClass("hidden-js");
                } else {
                    $(".quick-shopping-buttons-container-js").addClass("hidden-js");
                }
                $clickedButton.siblings().removeClass("active-js");
                $clickedButton.addClass("active-js");
                body.trigger("viewChange", viewName);
                thisRef.changeValidationConditions(viewName);
                let productsInCart;
                if (__productIsInCart === "productIsInCart-yes") {
                    app.getProductsIdsFromCart(function (res) {
                        productsInCart = res;
                    });
                    updateProductItemsInCartState(productsInCart);
                }
            }

            this.changeView = function (clickedButton, viewName) {
                const $clickedButton = $(clickedButton);
                this.selectedViewName = viewName;
                window.app.setCookie("selectedViewName", viewName, 360);
                const thisRef = this;
                $.get(
                    "",
                    { __template: "partials/products/products-list.html", __collection: "products.TotalItems" },
                    function (data) {
                        handleChangeViewResponse(data, viewName, $clickedButton, thisRef);
                    }
                );
            };

            this.changeValidationConditions = function (viewName) {
                let $viewName = viewName;
                if (!viewName) {
                    $viewName = this.selectedViewName;
                }

                let steppers = null;

                if (this.changableValidationClass) {
                    steppers = this.listContainer.find("." + this.changableValidationClass + '[name="quantity"]');
                } else {
                    steppers = this.listContainer.find('[name="quantity"]');
                }

                let thisRef = null;

                if ($viewName == "quick-shopping") {
                    steppers.addClass("zero-allowed-js");
                    steppers.data("min", 0);
                    if (__decUnits == "true") {
                        steppers.val("0" + __decSep + "00");
                    } else {
                        steppers.val("0");
                    }
                    steppers.each((_index, stepper) => {
                      stepper.dispatchEvent(new Event('input', { bubbles: true }));
                    });

                    this.listContainer.find(".increment-js").removeClass("disabled-js");
                    this.listContainer.find(".increment-js").prop("disabled", false);

                    this.listContainer.find(".decrement-js").addClass("disabled-js");
                    this.listContainer.find(".decrement-js").prop("disabled", true);

                    if (__decUnits == "false") {
                        steppers.each(function () {
                            var max = Number($(this).data("max").toString().replace(",", "."));
                            if (max < 1) {
                                $(this).next().addClass("disabled-js");
                                $(this).next().prop("disabled", true);
                            }
                        });
                    }

                    thisRef = this;
                    this.rangeValidators.each(function () {
                        $(this).find(".min-js").text("0");
                    });
                } else {
                    steppers.removeClass("zero-allowed-js");
                    if (__decUnits == "true") {
                        steppers.data("min", "0" + __decSep + "01");
                    } else {
                        steppers.data("min", "1");
                    }
                    thisRef = this;
                    let wasMultiplicity = false;
                    steppers.each(function () {
                        let min = Number($(this).data("min").toString().replace(",", "."));
                        const max = Number($(this).data("max").toString().replace(",", "."));
                        if (max < 1 && max != 0) {
                            var val = $(this).data("max");
                        } else {
                            if (__decUnits == "true") {
                                if (Number($(this).data("multiplicity")) > 0) {
                                    var val = $(this).data("multiplicity") + __decSep + "00";
                                    min = Number($(this).data("multiplicity").toString().replace(",", "."));
                                    $(this).data("min", min);
                                    wasMultiplicity = true;
                                } else {
                                    var val = "1" + __decSep + "00";
                                }
                            } else {
                                if (Number($(this).data("multiplicity")) > 0) {
                                    var val = $(this).data("multiplicity");
                                    min = Number($(this).data("multiplicity").toString().replace(",", "."));
                                    $(this).data("min", min);
                                    wasMultiplicity = true;
                                } else {
                                    var val = "1";
                                }
                            }
                        }
                        $(this).val(val);
                        val = Number(val.toString().replace(",", "."));
                        if (min >= max) {
                            $(this).prev().addClass("disabled-js");
                            $(this).prev().prop("disabled", true);
                            $(this).next().addClass("disabled-js");
                            $(this).next().prop("disabled", true);
                        } else if (val >= max) {
                            $(this).prev().removeClass("disabled-js");
                            $(this).prev().prop("disabled", false);
                            $(this).next().addClass("disabled-js");
                            $(this).next().prop("disabled", true);
                        } else if (val <= min) {
                            $(this).prev().addClass("disabled-js");
                            $(this).prev().prop("disabled", true);
                            $(this).next().removeClass("disabled-js");
                            $(this).next().prop("disabled", false);
                        } else {
                            $(this).prev().removeClass("disabled-js");
                            $(this).prev().prop("disabled", false);
                            $(this).next().removeClass("disabled-js");
                            $(this).next().prop("disabled", false);
                        }
                    });

                    this.rangeValidators.each(function () {
                        $(this).find(".min-js").text(thisRef.min);
                    });
                }
            };

            //serial adding to cart on quick shopping view
            this.serialAddingToCart = async function () {
                const forms = document.querySelectorAll(".add-to-cart-js");
                const parameters = [];

                forms.forEach((form) => {
                    const quantityInput = form.querySelector('input[name="quantity"]');

                    if (!quantityInput) {
                        return;
                    }

                    let quantity = Number(quantityInput.value.replace(__decSep, "."));

                    if (!quantity || quantity <= 0 || quantity > 99999) {
                        return;
                    }

                    const productIdInput = form.querySelector('input[name="productId"]');

                    if (!productIdInput) {
                        return;
                    }

                    const productId = productIdInput.value;

                    if (!productId) {
                        return;
                    }

                    if (__decUnits == "true" && __decSep != ".") {
                        quantity = quantity.toString().replace(".", __decSep);
                    }

                    parameters.push({
                        productId: productId,
                        quantity: quantity,
                    });
                });

                if (!parameters || parameters.length === 0) {
                    app.temporaryPopupMessage(undefined, __translations.fillQuantityOfChoosenProducts, "info");
                    return;
                }

                const data = {
                    __csrf: __CSRF,
                    __action: "Cart/Add",
                    __parameters: JSON.stringify(parameters),
                    __template: "partials/common/header/client-area.html",
                    __collection: "customer.Cart.Id",
                };

                try {
                    const response = await $.post("", data);
                    const products = response?.action?.Products;
                    const notAddedProducts = response?.action?.Results?.filter((item) => item.Code !== 0) || [];

                    if (response?.action.Code != 0) {
                        app.temporaryPopupMessage(undefined, response.action.Message, response.action.Type);
                        return;
                    }

                    let strategy;
                    if (notAddedProducts?.length > 0) {
                        strategy = "2";
                    } else {
                        strategy = __aatc;
                    }

                    window.dispatchEvent(
                        new CustomEvent("cart:added", {
                            detail: {
                                products: products,
                                strategy: strategy,
                            },
                        })
                    );

                    const isSingleProductNotAdded = !response?.action.Result && response?.action?.Object;
                    if (isSingleProductNotAdded || notAddedProducts?.length > 0) {
                        window.dispatchEvent(
                            new CustomEvent("validation:failure", {
                                detail: {
                                    results: notAddedProducts || [response.action],
                                },
                            })
                        );
                    }

                    $(".client-area-js").html(response.template);
                    changeHeaderCart();
                    window.app.setCookie("lastCartId", response.collection);
                } catch (error) {
                    console.error("Failed to add to cart from quick shopping list: ", error);
                } finally {
                    let minAmount;
                    if (__decUnits === true || __decUnits == "true") {
                        minAmount = "0" + __decSep + "01";
                    } else {
                        minAmount = "1";
                    }
                    minAmount = minAmount.replace(".", __decSep);
                    window.productList = new ProductList(".view-container-js", ".product-item-js", "-view-js", minAmount, ".validation-quantity-range-js", "changeable-js");
                }
            };

            // changes options in filtering form and triggers filter function
            this.resetChoosenFilter = function (e, filterFormSelector, filterName, filterValue) {
                const filterForm = $(filterFormSelector);
                const inputs = filterForm.find('[type="hidden"]:not([name="__action"])');
                const inputsAmount = inputs.length;
                const params = location.search.replace(/\?/g, "").split("&");
                let newQueryString = "";
                let ftr = false;
                for (const i in params) {
                    if (params[i].indexOf("pageId=") == -1) {
                        if (params[i].indexOf("search") == -1 && filterName == "search") {
                            if (i == 0) {
                                newQueryString += params[i];
                            } else {
                                newQueryString += "&" + params[i];
                            }
                        }
                        if (params[i].indexOf("ftrLst") == -1) {
                            ftr = true;
                        }
                    }
                }
                if (filterName == "search") {
                    if (newQueryString == "&seaAdv=1") {
                        newQueryString = "";
                    } else if (newQueryString != "") {
                        newQueryString = "?" + newQueryString;
                    } else {
                        newQueryString = "";
                    }
                    location.href = location.pathname + newQueryString;
                    return;
                } else if ((filterName == "all" || inputsAmount == 1) && ftr) {
                    inputs.remove();
                } else if (filterName == "$minPrice" || filterName == "$maxPrice") {
                    filterForm.find('[name="' + filterName + '"]').remove();
                } else {
                    filterForm.find('[name="' + filterName + '"][value="' + filterValue + '"]').remove();
                }
                window.app.filter(e);
            };

            // get more values for choosen filter and shows them
            this.showMoreFilterValues = function (e) {
                const additionalFilters = $(e.currentTarget).parent().find(".filters-container-js");
                const container = $(e.currentTarget).parents(".values-js");
                const height = additionalFilters.find(".filters-js").height();
                const maxHeight = additionalFilters.height();
                const checkbox = additionalFilters.find(".checkbox-js label");
                if (maxHeight > 0) {
                    checkbox.attr("tabindex", "-1");
                    additionalFilters.css("maxHeight", 0);
                    const containerHeight = container.height();
                    let maxHeightValue;
                    if (containerHeight > 500) {
                        maxHeightValue = containerHeight;
                    } else {
                        maxHeightValue = 500;
                    }
                    container.data("maxHeight", maxHeightValue);
                    container.css("maxHeight", container.data("maxHeight"));
                } else {
                    checkbox.attr("tabindex", "0");
                    additionalFilters.css("maxHeight", height);
                    container.css("maxHeight", height + 500);
                }
            };
            this.changeValidationConditions();
        }

        //PRODUCT LIST binding

        //init
        let minAmount;
        if (__decUnits === true || __decUnits == "true") {
            minAmount = "0" + __decSep + "01";
        } else {
            minAmount = "1";
        }
        minAmount = minAmount.replace(".", __decSep);
        window.productList = new ProductList(".view-container-js", ".product-item-js", "-view-js", minAmount, ".validation-quantity-range-js", "changeable-js");
        let productsInCart;
        if (__productIsInCart == "productIsInCart-yes") {
            app.getProductsIdsFromCart(function (res) {
                productsInCart = res;
            });
            $(".product-item-js").each(function (index) {
                const productId = parseInt($(this).find(".isInCartId").val());
                if (!isNaN(productId)) {
                    const isInCart = app.checkIfProductIsInCart(productsInCart, productId);
                    app.enableDisableInCartButton(isInCart, 2, index);
                }
            });
        }
        //views change
        body.on("click", ".change-view-js", function () {
            let minAmount;
            if (__decUnits === true || __decUnits == "true") {
                minAmount = "0" + __decSep + "01";
            } else {
                minAmount = "1";
            }
            minAmount = minAmount.replace(".", __decSep);
            window.productList = new ProductList(".view-container-js", ".product-item-js", "-view-js", minAmount, ".validation-quantity-range-js", "changeable-js");
            window.productList.changeView(this, $(this).data("view"));
        });

        body.on("click", ".replace-products-list-template-js", function (e) {
            var classRegex = new RegExp("[\\w|-]*" + "-view-js");
            let nameFromHTML = null;
            if ($(".view-container-js").length > 0) {
                nameFromHTML = $(".view-container-js").attr("class").match(classRegex)[0].replace("-view-js", "");
            }
            let nameWhenThresholds = null;
            if ($(".view-container-js").hasClass("with-thresholds-js")) {
                nameWhenThresholds = "list";
            }
            var selectedViewName = nameWhenThresholds || window.app.getCookie("selectedViewName") || nameFromHTML || "quick-shopping";
            if (selectedViewName == "quick-shopping") {
                $(".after-adding-to-cart-popup-js").addClass("hidden-js");
                $(".after-adding-to-cart-popup-js .products-js").html("");
            } else {
                app.replaceTemplate(e, "", function () {
                    let minAmount;
                    if (__decUnits === true || __decUnits == "true") {
                        minAmount = "0" + __decSep + "01";
                    } else {
                        minAmount = "1";
                    }
                    minAmount = minAmount.replace(".", __decSep);
                    window.productList = new ProductList(".view-container-js", ".product-item-js", "-view-js", minAmount, ".validation-quantity-range-js", "changeable-js");
                });
            }
        });

        //resetingFilters
        body.on("click", ".selected-filter-item-js", function (e) {
            e.preventDefault(e);

            const btn = e.currentTarget;
            const val = btn.getAttribute("data-value");
            const field = btn.getAttribute("data-field");
            const allInput = document.querySelectorAll(".filterSetAmount-js");
            let d;
            const selectedFilterItem = document.querySelectorAll(".selected-filter-item-js");

            if (field == "$maxPrice" || field == "$minPrice") {
                let input;

                if (field == "$maxPrice") {
                    input = document.querySelector('input[name="$maxPrice"]');
                } else {
                    input = document.querySelector('input[name="$minPrice"]');
                }

                if (input) {
                    input.value = "";
                }
                if (document.querySelector(".filter-js") != null) {
                    d = $(".filter-js input").serializeArray();
                } else {
                    d = $(".checkbox-js input").serializeArray();
                }

                d.push({ name: "__action", value: "get/SearchFilters" });
            } else if (field == "all" || selectedFilterItem.length == 2) {
                var form = $(".product-filters-js");
                form.find('[type="tel"]').val("");
                form.find('[type="checkbox"]').prop("checked", false);
                d = $(".filter-js input").serializeArray();

                d.push({ name: "__action", value: "get/SearchFilters" });
                app.resetFilters(e, d);
            } else {
                for (const input of allInput) {
                    const allInputsI = input.children[0];

                    if (allInputsI.name == field && allInputsI.value == val) {
                        allInputsI.checked = false;
                        if (document.querySelector(".filter-js") != null) {
                            d = $(".filter-js input").serializeArray();
                            const d1 = $(".filterPrice-js input").serializeArray();
                            d = d.concat(d1);
                        } else {
                            d = $(".checkbox-js input").serializeArray();
                        }
                        d.push({ name: "__action", value: "get/SearchFilters" });
                    }
                }
            }
            app.showClearFiltersBtn();
            app.filtersAmout();
            return $.ajax({
                url: window.location.href,
                method: "GET",
                action: "get/SearchFilters",
                data: d,
                template: "partials/products/products-list-item.html",
                success: function (data) {
                    location.href = data.action.Redirect302;
                },
            });
        });

        //get more filter values
        body.on("click", ".more-filter-items-js", function (e) {
            window.productList.showMoreFilterValues(e);
        });

        //serial adding to cart
        body.on("click", ".serial-adding-to-cart-js", async function (e) {
            e.preventDefault();
            window.productList.serialAddingToCart(e);
        });

        $(".content-container").each(function () {
            const container = $(this).find(".content-container__attributes");
            const expandLink = $(this).find(".see-more__button");

            if (expandLink.length) {
                const scrollHeight = container.get(0).scrollHeight;
                const innerHeight = container.innerHeight();
                const tolerance = 2;

                const isScrollable = scrollHeight - tolerance > innerHeight;

                if (isScrollable) {
                    expandLink.removeClass("hidden-js");
                } else {
                    expandLink.addClass("hidden-js");
                }
            }
        });

        $(window).on("resize", function () {
            $(".content-container").each(function () {
                const container = $(this).find(".content-container__attributes");
                const expandLink = $(this).find(".see-more__button");

                if (expandLink.length) {
                    const scrollHeight = container.get(0).scrollHeight;
                    const innerHeight = container.innerHeight();
                    const tolerance = 2;

                    const isScrollable = scrollHeight - tolerance > innerHeight;

                    if (isScrollable) {
                        expandLink.removeClass("hidden-js");
                    } else {
                        expandLink.addClass("hidden-js");
                    }
                }
            });
        });

        /**
         * Handles blur event for mobile options toggle.
         * Hides the more options menu unless focus moves within the menu.
         * @param {FocusEvent} e
         */
        $('body').on('blur', '.toggle-options-mobile-js', (e) => {
            const related = e.relatedTarget;
            const select = e.currentTarget.nextElementSibling;
            if (related?.parentElement === select) {
                return;
            }

            select.classList.add('hidden-js');
            e.currentTarget.ariaLabel = __translations.ShowMore;
        });

        /**
         * Handles click event on mobile more options.
         * Hides the clicked more options menu.
         * @param {MouseEvent} e
         */
        $('body').on('click', '.more-options-mobile-js', (e) => {
            e.currentTarget.classList.add('hidden-js');
            e.currentTarget.previousElementSibling.ariaLabel = __translations.ShowMore;
        });

        /**
         * Handles click event on mobile options toggle.
         * Toggles visibility of the next sibling menu.
         * @param {MouseEvent} e
         */
        $('body').on('click', '.toggle-options-mobile-js', (e) => {
            const button = e.currentTarget;
            const select = e.currentTarget.nextElementSibling;
            select.classList.toggle('hidden-js');
            if (button.ariaLabel === __translations.ShowMore) {
                button.ariaLabel = __translations.ShowLess;
            } else {
                button.ariaLabel = __translations.ShowMore;
            }
        });

        /**
         * Updates comparison button text and classes when a product is added to comparison.
         * @param {CustomEvent} e
         */
        window.addEventListener('comparer:added', async (e) => {
            const productId = e.detail.productId;
            const productIdSelector = '[data-product-id="' + productId + '"]'

            const button = document.querySelector('.add-to-comparison-js:not(.mobile-comparison-btn-js)' + productIdSelector);
            const buttonMobile = document.querySelector('.mobile-comparison-btn-js' + productIdSelector);

            if (!button) {
                return;
            }

            const span = button.querySelector('span');
            const spanMobile = buttonMobile.querySelector('span');
            if (span) {
                span.innerText = __translations.Delete;
                spanMobile.innerText = __translations.DeleteFromCompare;
            }

            const addToComparisonClass = 'add-to-comparison-js';
            const removeFromComparisonClass = 'remove-from-comparison-js';

            button.classList.replace(addToComparisonClass, removeFromComparisonClass);
            buttonMobile.classList.replace(addToComparisonClass, removeFromComparisonClass);
        });

        /**
         * Updates comparison button text and classes when a product is removed from comparison.
         * Shows a temporary popup message.
         * @param {CustomEvent} e
         */
        window.addEventListener('comparer:removed', (e) => {
            const productId = e.detail.productId;
            const productIdSelector = '[data-product-id="' + productId + '"]'

            const button = document.querySelector('.remove-from-comparison-js:not(.mobile-comparison-btn-js)' + productIdSelector);
            const buttonMobile = document.querySelector('.mobile-comparison-btn-js' + productIdSelector);

            if (!button) {
                return;
            }
            
            const span = button.querySelector('span');
            const spanMobile = buttonMobile.querySelector('span');
            if (span) {
                span.innerText = __translations.Compare;
                spanMobile.innerText = __translations.Compare;
            }

            const addToComparisonClass = 'add-to-comparison-js';
            const removeFromComparisonClass = 'remove-from-comparison-js';

            button.classList.replace(removeFromComparisonClass, addToComparisonClass);
            buttonMobile.classList.replace(removeFromComparisonClass, addToComparisonClass);

            app.temporaryPopupMessage(null, __translations.SuccessfullyDeletedFromComparison, "msg");
        });
    }
})();

`